<template>
  <v-card color="grey lighten-3" class="pa-2 mb-3">
    <v-card-title>
      <h4 class="subheading my-0">Formación y categoría laboral</h4>
    </v-card-title>
    <v-text-field
      v-model="formData.titulacion"
      :disabled="disabled"
      :label="$t('Titulación/Nivel formativo')"
      box
    ></v-text-field>
    <v-text-field
      v-model="formData.categoria_profesional"
      :disabled="disabled"
      :label="$t('Categoría profesional')"
      :rules="[rules.required]"
      required
      box
    ></v-text-field>
    <v-textarea
      v-model="formData.descripcion_puesto_trabajo"
      :disabled="disabled"
      :label="$t('Descripción puesto de trabajo')"
      box
    ></v-textarea>
  </v-card>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default() {
        return {
          titulacion: null,
          categoria_profesional: null,
          descripcion_puesto_trabajo: null,
        };
      },
    },
  },
  data() {
    return {
      rules: {
        required: value => !!value || 'Este campo es obligatorio.',
        counter: value => value.length <= 20 || 'Max 20 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || 'Email inválido';
        },
      },
    };
  },
  computed: {
    formData: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  mounted() {},
  methods: {},
  watch: {},
};
</script>

<style lang="scss"></style>
